import React from 'react';

import GithubIcon from './assets/github.svg';
import LinkedInIcon from './assets/linked-in.svg';
import SocialButton from './components/SocialButton';
import useStyles from './styles';

interface Props {
    className?: string;
}

const PageBottom: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <span className={classes.copyright}>{`© Vulners inc. ${new Date().getFullYear()}`}</span>
            <div className={classes.socials}>
                <SocialButton
                    icon={<LinkedInIcon />}
                    link="https://www.linkedin.com/company/vulners"
                    tooltip="LinkedIn"
                />
                <SocialButton icon={<GithubIcon />} link="https://github.com/vulnerscom" tooltip="GitHub" />
            </div>
        </div>
    );
};

export default PageBottom;
